import React from 'react';
import { ContentSection, ContentContainer, ContentTitle, ContentCopy } from './Content.style';

export type ContentProps = React.PropsWithChildren<{
  className?: string,
  title: string,
  as?: string,
  content?: string,
  size?: string,
}>;

export const Content = ({ className, title, as='h2', content, size='sm', children }: ContentProps): JSX.Element => {
  return (
    <ContentSection className = {className} size={size}>
      <ContentContainer>
        <ContentTitle as={as}>{title}</ContentTitle>
        <ContentCopy dangerouslySetInnerHTML={content ? { __html: content } : undefined}>{children}</ContentCopy>
      </ContentContainer>
    </ContentSection>
  );
};
